// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cardContainer {\n    border: 1px solid lightgray;\n    padding: 1rem;\n    margin-bottom: 1rem;\n}", ""]);
// Exports
module.exports = exports;
